import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import javitsImage from "@/assets/javits-center.jpg";
import hyattImage from "@/assets/hyatt-regency-phoenix.jpg";

const locations = [
  {
    title: "The Javits Center",
    subtitle: "New York City, NY",
    description: "Escape the convention floor noise. Find a private, soundproof space to take calls and focus right inside the Javits.",
    image: javitsImage,
    buttonText: "View NYC Pods",
    link: "/book/JavitsAdvancedRez",
    attribution: {
      author: "Ajay Suresh",
      url: "https://www.flickr.com/photos/ajay_suresh/49052081016/",
    },
  },
  {
    title: "Hyatt Regency Downtown",
    subtitle: "Phoenix, AZ",
    description: "Your private workspace in the heart of downtown. Located conveniently in the Atrium and Lobby.",
    image: hyattImage,
    buttonText: "View Phoenix Pods",
    link: "/book/PHXHyattAdvancedrez",
    attribution: null,
  }
];

const Book = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="container mx-auto px-4 py-20">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="font-montserrat text-4xl md:text-5xl lg:text-6xl font-extrabold text-foreground mb-4">
              Select Your Location
            </h1>
            <p className="text-lg text-muted-foreground">
              Choose a Quiet Corner location to book your private workspace
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {locations.map((location, index) => (
              <Card 
                key={index} 
                className="overflow-hidden rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300 bg-card"
              >
                <Link to={location.link} className="block aspect-[16/10] overflow-hidden relative">
                  <img 
                    src={location.image} 
                    alt={location.title}
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                  />
                </Link>
                {location.attribution && (
                  <p className="text-xs text-muted-foreground px-6 pt-2">
                    Photo by{" "}
                    <a href={location.attribution.url} target="_blank" rel="noopener noreferrer" className="underline hover:text-foreground">
                      {location.attribution.author}
                    </a>
                    , licensed under{" "}
                    <a href="https://creativecommons.org/licenses/by/2.0/" target="_blank" rel="noopener noreferrer" className="underline hover:text-foreground">
                      CC BY 2.0
                    </a>
                  </p>
                )}
                <CardContent className="p-6">
                  <Link to={location.link}>
                    <h2 className="font-montserrat text-2xl font-bold text-foreground mb-2 hover:text-primary transition-colors">
                      {location.title}
                    </h2>
                  </Link>
                  <div className="flex items-center gap-1 text-primary mb-4">
                    <MapPin className="w-4 h-4" />
                    <span className="text-sm font-medium">{location.subtitle}</span>
                  </div>
                  <p className="text-muted-foreground mb-6 leading-relaxed">
                    {location.description}
                  </p>
                  <Button 
                    asChild
                    className="w-full bg-primary hover:bg-primary/90 text-primary-foreground font-medium"
                  >
                    <Link to={location.link}>{location.buttonText}</Link>
                  </Button>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Book;
